import { Navigate } from "react-router-dom";

export default function Main() {
  return <Navigate to="/news" />;
}
